import React, { Suspense } from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { ROUTE_ACCESS } from './routeAccess';
import PublicRoute from './PublicRoute';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <PublicRoute>
                                    <NonAuthLayout>
                                        <Suspense fallback={<div>Loading...</div>}>
                                            {route.component}
                                        </Suspense>
                                    </NonAuthLayout>
                                </PublicRoute>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => {
                        const access = ROUTE_ACCESS[route.path] || {};

                        return (
                            <Route
                                key={idx}
                                path={route.path}
                                element={
                                    <AuthProtected>
                                        <VerticalLayout>
                                            <Suspense fallback={<div>Loading...</div>}>
                                                {route.component}
                                            </Suspense>
                                        </VerticalLayout>
                                    </AuthProtected>
                                }
                            />
                        );
                    })}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;